import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { getRetailer, updateRetailer } from "../../services/retailer.service";

export default function RetailerUpdate() {
  const [isLoading2, setIsLoading2] = useState(false);
  const { token } = useSelector((state) => state?.auth);
  const navigate = useNavigate();
  const [retailer, setRetailer] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const retailerID = params.get("id");

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const fetchRetailer = async () => {
    try {
      const res = await getRetailer(token, retailerID);
      if (res && res.status >= 200 && res.status < 300) {
        setRetailer(res?.data);
        console.log("retailer data fetched successfully:", res.data);
      } else {
        Swal.fire(
          "Error",
          res?.data?.message || "Failed to fetch agent. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching agent:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    if (retailerID) {
      fetchRetailer();
    }
  }, [retailerID]);

  useEffect(() => {
    if (retailer) {
      setValue("ownerName", retailer?.owner_name);
      setValue("retailerEmail", retailer?.email);
      setValue("retailerNumber", retailer?.mobile);
      setValue("retailerAddress", retailer?.address);
      setValue("shopName", retailer?.shop_name);
      setValue("gstNumber", retailer?.gst_number);
    }
  }, [retailer]);

  const onSubmit = async (item) => {
    setIsLoading2(true);

    console.log(item);

    const data = {
      email: item.retailerEmail,
      mobile_number: item.retailerNumber,
      shop_name: item.shopName,
      PAN_number: item.panNumber,
      GST_number: item.gstNumber,
      owner_name: item.ownerName,
      address: item.retailerAddress,
    };

    try {
      const res = await updateRetailer(token, data, retailerID);

      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire({
          title: "Updated!",
          text: `${item.ownerName} Retailer has been updated successfully.`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/retailer");
        });
      } else if (res && res.status >= 400 && res.status < 500) {
        Swal.fire(
          "Error",
          res?.data?.message || "Invalid input. Please check your data.",
          "error"
        );
      } else {
        Swal.fire(
          "Error",
          res?.data?.error || "An unexpected error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during updating main Retailer:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    } finally {
      setIsLoading2(false);
    }
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Update Retailer</h4>
                <Link to="/retailer">
                  <img src="/assets/images/kidskart/icon/back-button.png" />
                </Link>{" "}
              </div>
              <div className="card-body py-3">
                <div className="basic-form">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      {/* shop Name */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Shop Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter shop name"
                          {...register("shopName", {
                            required: "Shop name is required",
                          })}
                        />
                        {errors.shopName && (
                          <p className="error">{errors.shopName.message}</p>
                        )}
                      </div>

                      {/* retailer Name */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Retailer Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter retailer name"
                          {...register("ownerName", {
                            required: "Retailer name is required",
                          })}
                        />
                        {errors.ownerName && (
                          <p className="error">{errors.ownerName.message}</p>
                        )}
                      </div>

                      {/* Retailer Email */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Retailer Email</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Retailer Email"
                          {...register("retailerEmail", {
                            required: "Email is required",
                          })}
                        />
                        {errors.retailerEmail && (
                          <p className="error">
                            {errors.retailerEmail.message}
                          </p>
                        )}
                      </div>

                      {/* retailer Phone */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Contact Number</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Contact Number"
                          {...register("retailerNumber", {
                            required: "Mobile contact is required",
                          })}
                        />
                        {errors.retailerNumber && (
                          <p className="error">
                            {errors.retailerNumber.message}
                          </p>
                        )}
                      </div>

                      {/* PAN Number */}
                      <div className="mb-4 col-md-6">
                        <label className="form-label">PAN Number</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter PAN Number"
                          maxLength={30}
                          {...register("panNumber", {
                            pattern: {
                              // value: panRegex,
                              message: "Please enter a valid PAN number",
                            },
                          })}
                        />
                        {errors.panNumber && (
                          <p className="error">{errors.panNumber.message}</p>
                        )}
                      </div>

                      {/* GST Number */}
                      <div className="mb-4 col-md-6">
                        <label className="form-label">GST Number</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter GST Number"
                          maxLength={30}
                          {...register("gstNumber")}
                        />
                      </div>

                      {/* Retailer Address */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Retailer Address</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <textarea
                          type="text"
                          className="form-control"
                          placeholder="Enter retailer address"
                          maxLength={200}
                          {...register("retailerAddress", {
                            required: "Address is required",
                          })}
                        />
                        {errors.retailerAddress && (
                          <p className="error">
                            {errors.retailerAddress.message}
                          </p>
                        )}
                      </div>

                      {/* Status */}
                      {/* <div className="mb-4 col-md-6">
                        <label className="form-label">Status</label>
                        <select
                          className="form-control custom-select dropdown-arrow"
                          {...register("status", {
                            required: "Status is required",
                          })}
                        >
                          <option value="">Select status</option>
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                        {errors.status && (
                          <p className="error">{errors.status.message}</p>
                        )}
                      </div> */}
                    </div>

                    {!isLoading2 ? (
                      <div className="col-sm-4">
                        <button type="submit" className="btn btn-primary w-100">
                          UPDATE RETAILER
                        </button>
                      </div>
                    ) : (
                      <div className="col-sm-4">
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          disabled
                        >
                          UPDATING RETAILER
                        </button>

                        <div
                          className="spinner-border2 text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
